import React from 'react';
import moment from 'moment-timezone';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { openModal } from '../../redux/actions';
import { InvalidCross, objectIsEmpty } from '../../utils';

import {
  MembershipColumns,
  MembershipColumn,
  MembershipHeading,
  SpecialPerksContainer,
  SpecialPerksBadge,
  UserInfoColumns,
  UserInfoColumn,
  UserInfoHeading,
  UserInfoDescription,
  UserInfoRow,
  CancelSubscriptionButton,
  FaqButton,
  MembershipBadge,
  MembershipBadgeType,
  MembershipBadgePrice,
  MembershipBadgeDescription,
  RulesList,
} from './styles';

const MembershipSection = ({ subscriptionInfo, onCancelClick }) => {
  
  const { code, price, bookedDate, type, name, highlight, description, status, endDate, StatusPause } = subscriptionInfo;

  if ( status==1 && StatusPause==0 ) {
    return 'No subscription';
  }

  return (
    <div>
      <MembershipColumns>
        <MembershipColumn>
          <MembershipBadge>
            <MembershipBadgeType type={type}>{name}</MembershipBadgeType>
            <MembershipBadgeDescription>{highlight}</MembershipBadgeDescription>
            <MembershipBadgePrice>
              ${price / 100}<span>/month</span>
            </MembershipBadgePrice>
          </MembershipBadge>
        </MembershipColumn>
        <MembershipColumn>
          <UserInfoColumns>
            <UserInfoColumn>
              <SpecialPerksContainer />
              <UserInfoHeading>Membership ID</UserInfoHeading>
              <UserInfoDescription>{code}</UserInfoDescription>
            </UserInfoColumn>
            <UserInfoColumn>
              <SpecialPerksContainer>
                <SpecialPerksBadge>Special Perks</SpecialPerksBadge>
              </SpecialPerksContainer>
              <UserInfoHeading>Goldfriend</UserInfoHeading>
              <UserInfoDescription>10% OFF additional passes for friends & family, limit 2 uses per month</UserInfoDescription>
            </UserInfoColumn>
          </UserInfoColumns>
        </MembershipColumn>
      </MembershipColumns>
      <MembershipColumns>
        <MembershipColumn>
          <MembershipHeading>Plan Rules</MembershipHeading>
          <RulesList dangerouslySetInnerHTML={{ __html: description  }} />
        </MembershipColumn>
        <MembershipColumn>
          <MembershipHeading>Your Current Cycle</MembershipHeading>
          {status === 0 && (
            <>
              <UserInfoColumns>
                <UserInfoColumn>
                  <UserInfoHeading>Valid through</UserInfoHeading>
                  <UserInfoDescription>{moment(bookedDate).format('MMM DD, YYYY')}</UserInfoDescription>
                </UserInfoColumn>
                <UserInfoColumn>
                  <UserInfoHeading>Next cycle begins</UserInfoHeading>
                  <UserInfoDescription>{moment(bookedDate).add(1, 'month').format('MMM DD, YYYY')}</UserInfoDescription>
                </UserInfoColumn>
              </UserInfoColumns>
              <UserInfoRow>
                <CancelSubscriptionButton onClick={() => onCancelClick('cancelSubscription')}>
                  <InvalidCross />
                  Cancel subscription
                </CancelSubscriptionButton>
                <FaqButton href="https://dayaxe.zendesk.com/hc/en-us/categories/115000289754-Gold-Pass-Membership" target="_blank" rel="noopener noreferrer">FAQ</FaqButton>
              </UserInfoRow>
            </>
            ) || status === 1 && StatusPause === 0 && moment(endDate).isAfter(moment()) && (
              <UserInfoColumns>
                <UserInfoColumn>
                  <UserInfoHeading>Your subscription is canceled. It will end on</UserInfoHeading>
                  <UserInfoDescription>{moment(endDate).format('MMM DD, YYYY')}</UserInfoDescription>
                </UserInfoColumn>
              </UserInfoColumns>
            ) || status === 1 && StatusPause === 1 && moment(endDate).isAfter(moment()) && (
              <UserInfoColumns>
                <UserInfoColumn>
                  <SpecialPerksBadge>Your subscription will pause after</SpecialPerksBadge>
                  <UserInfoDescription>{moment(endDate).format('MMM DD, YYYY')}</UserInfoDescription>
                </UserInfoColumn>
              </UserInfoColumns>
            ) || StatusPause === 1 && (
              <UserInfoColumns>
                <UserInfoColumn>
                  <SpecialPerksBadge>Your subscription is currently paused, during this time there will be no charges to your payment method</SpecialPerksBadge>
                </UserInfoColumn>
              </UserInfoColumns>
            )
            }
        </MembershipColumn>
      </MembershipColumns>
    </div>
  );
};

MembershipSection.propTypes = {
  subscriptionInfo: PropTypes.instanceOf(Object),
  onCancelClick: PropTypes.func,
};

const mapDispatchToProps = dispatch => bindActionCreators({
  onCancelClick: openModal,
}, dispatch);

export default connect(null, mapDispatchToProps)(MembershipSection);
